import { Col, Input, Label, Row } from 'reactstrap';
import { COST_SUMMARY } from '../constants';
import { toFixedTwoDecimal } from '../../../utils/number.util';

function ShowCost({ headerDetails, isClone }) {
  const getDisplayValue = (key, details, totalCost, actualCost) => {
    if (key === 'tqc') return toFixedTwoDecimal(totalCost) ?? '0.00';
    if (key === 'tac') return toFixedTwoDecimal(actualCost) ?? '0.00';
    if (details?.[key]) return toFixedTwoDecimal(details[key]);
    return '0.00';
  };

  const totalCost =
    parseFloat(headerDetails?.FlightQuoteCost ?? 0) +
    parseFloat(headerDetails?.HotelQuoteCost ?? 0) +
    parseFloat(headerDetails?.AirportTransferQuoteCost ?? 0) +
    parseFloat(headerDetails?.InsuranceQuoteCost ?? 0) +
    parseFloat(headerDetails?.VisaQuoteCost ?? 0);
  const actualCost =
    parseFloat(headerDetails?.FlightCost ?? 0) +
    parseFloat(headerDetails?.HotelCost ?? 0) +
    parseFloat(headerDetails?.AirportTransferCost ?? 0) +
    parseFloat(headerDetails?.InsuranceCost ?? 0) +
    parseFloat(headerDetails?.VisaCost ?? 0);

  return (
    <div className="new-travel-request-card p-3 bg-white" hidden={isClone}>
      <div className="fw-semibold mb-2 fs-5">Cost Summary</div>
      <Row>
        {COST_SUMMARY?.map((item, index) => {
          const isCount = item?.key === 'tqc' || item.key === 'tac';
          return (
            <Col key={index} xs={12} md={4} className="mb-3">
              <Label>
                {item?.value}
                {!isCount && <span className="text-danger">*</span>}
              </Label>
              {item?.type === 'string' ? (
                <Input
                  className="external-filter-input"
                  readOnly
                  value={headerDetails?.[item?.key] ?? ''}
                />
              ) : (
                <Input
                  readOnly
                  className="external-filter-input"
                  style={{
                    fontWeight: isCount ? 'bold' : 'normal',
                  }}
                  value={getDisplayValue(
                    item?.key,
                    headerDetails,
                    totalCost,
                    actualCost,
                  )}
                />
              )}
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
export default ShowCost;
